<template>
  <div id="app">
    <template v-if="ispanaray">
      <Webapp/>
    </template>
    <template v-else>
      <Pannaryapp/>
    </template>
  </div>
</template>

<script>
import Webapp from "./components/Webapp.vue";
import Pannaryapp from "./components/Pannaryapp.vue";
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue/dist/bootstrap-vue.css";
import "@/assets/css/rvstyle.css";
import { mapState, mapActions } from "vuex";
import $ from 'jquery'

export default {
  name: "App",
  components: {
    Webapp,
    Pannaryapp
  },
  computed: {
    ...mapState({
      ispanaray: state => !state.appsetting.panaray
    })
  }
};
</script>



// WEBPACK FOOTER //
// src/App.vue